import { PersonalCertificateResultV2 } from '@sdir/httpclient/lib/clients/aps/personalcertificate';
import { createContext } from 'react';
import { Loadable } from '../../types';

export interface IOwnCertificateContext {
  ownCertificates: Loadable<PersonalCertificateResultV2[]>;
  refresh?: () => void;
}

export const OwnCertificateContext = createContext<IOwnCertificateContext>({
  ownCertificates: {
    loading: false,
    result: null,
    error: null,
  },
});
